angular.module('pitch.app')
.controller('NavbarCtrl', function($scope, SiteContext, $state, $rootScope, $timeout, fcDropnavCtrl) {
    "use strict";

    SiteContext.get().then(function(r) {
        $scope.site = r;
    });

    var destroyFnSet = $rootScope.$on('SITE_CONTEXT_SET', function(e, site) {
        $timeout(function() {
            $scope.$apply(function() {
                $scope.site = site;
            });
        }, 100);
    });

    $scope.$state = $state;

    // multiple menu content

    $scope.menu = 'main';

    $scope.setMenu = function(name) {
        if ($scope.menu !== name) {
            fcDropnavCtrl.set(true);
        } else {
            fcDropnavCtrl.toggle();
        }

        $scope.menu = name;
    };

    var destroyFnFail = $rootScope.$on('SITE_CONTEXT_FAIL', function() {
        $timeout(function() {
            $scope.menu = 'site';
            fcDropnavCtrl.set(true);
        }, 1000);
    });

    $scope.$on('$destroy', function() {
        destroyFnFail();
        destroyFnSet();
    });
});



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/NavbarCtrl.js